import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import * as Highcharts from 'highcharts';
import {Options} from 'highcharts';
import {TrendChartService} from "../../services/trend-chart/trend-chart.service";
import moment from "moment";
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-perf-trend',
  templateUrl: './perf-trend.component.pug',
  styleUrls: ['./perf-trend.component.scss'],
  standalone: false
})
export class PerfTrendComponent implements OnInit, OnChanges {

  @Input() perfTrend!: any;
  updateFlag = false;

  dateFormat = new Map([
    ["dates", "YYYY-MM-DD"],
    ["weeks", "YYYY_W"],
    ["months", "YYYY_MM"],
    ["quarters", "YYYY_Q"],
    ["years", "YYYY"],
  ]);
  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Options = TrendChartService.getOptions([], 0, 10, 230, 800, '#FFF', 'rgb(50,115,95)', 'rgb(255, 255, 255)', '#32735F', '');

  constructor(public permissions:PermissionsService) {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    let result_type = this.dateFormat.get(this.perfTrend['result_type']);
    let series: any = [];
    for (let d of this.perfTrend["result"]) {
      let date = moment.utc(d['date'], result_type).toDate().getTime();
      if (d['value'] != 0) {
        series.push([date, Math.round(((9 * (d['value'] - 1)) / 4) + 1)]);
      } else {
        series.push([date, 0]);
      }
    }
    this.chartOptions.yAxis = {tickInterval:10};
    TrendChartService.setChartOptionsFromData(this.chartOptions, series, result_type);
    this.updateFlag = true;
  }
}
